// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qu-0";